<div class="block-schedule__top">
   <ridango-ui-back-button (onBack)="back()">{{ 'LOCAL_BTN_BACK' | translate }}</ridango-ui-back-button>

    <div class="flex-center">
        <span role="text" attr.aria-label="{{'SCHEDULE_ARIA_LABEL_ROUTE_NAME' | translate}}} {{routeName}}"
        class="flex-center route-list--number">
        {{routeName}}
        </span>

        <div class="flex flex-column flex1 route-detail-description">
            <h1 class="remove-margin">{{stopName}}</h1>
            <p class="remove-margin">{{directionName}}</p>
        </div>
    </div>
</div>

<div role="menu" tabindex="0" class="block-tab-link-items padding-left-20 padding-right-20 route-detail-calendar">
    <a tabindex="0" role="menuitem" class="flex-center link" *ngFor="let day of (scheduleDays$ | async)"
    [ngClass]="{'block-tab-link-items--active': (day$ | async) === day}"
        (click)="changeDay(day)" (keydown.space)="changeDay(day)" (keydown.enter)="changeDay(day)"
    >
        {{ 'LOCAL_CALENDAR_'+(day | uppercase)+'_dddd' | translate }}
    </a>
</div>

<div class="block-schedule__bottom">
    <ul class="remove-bullets route-list" *ngIf="earlierDepartures.length > 0">
        <li *ngFor="let departure of earlierDepartures">
            <a class="link link--no-line link--no-hover flex-center full-width min-height-60"
                [routerLink]="['/schedule/routes', routeId, 'directions', directionId, 'stops', stopId, 'trips', departure.trip_id ]  | localize">
                <div class="flex flex1 position-relative min-height-50 padding-10">
                    <span class="flex1 margin-right-10 align-self-center" role="text">
                        {{departure.departure_time | timeFromString:'hh:mm'}}
                    </span>

                    <span class="icon icon-arrow-right-link align-self-center"></span>

                    <div class="route-list--hr"></div>
                </div>
            </a>
        </li>
    </ul>

    <div *ngIf="laterHours.length > 0">
        <h3 class="margin-top-20">{{'SCHEDULE_ROUTE_STOP_DETAILS_SCHEDULE_TITLE' | translate}}</h3>
        <ul class="remove-bullets route-list route-detail-graphic">
            <li *ngFor="let hour of laterHours" class="flex-center">
                <span class="bold hour flex-center margin-right-10">{{hour}}</span>
                <div class="flex flex1 position-relative min-height-50 border-bottom-1 padding-10 align-self-center flex-wrap">
                    <a class="link link--no-line link--no-hover align-self-center margin-right-10" *ngFor="let departure of laterDepartures[hour]"
                    [ngClass]="{ 'wheelchair-accessible': departure.variations && departure.variations.wheelchair_accessible }"
                    [routerLink]="['/schedule/routes', routeId, 'directions', directionId, 'stops', stopId, 'trips', departure.trip_id ]  | localize"
                    >
                        {{departure.departure_time | timeFromString:'mm'}}

                    </a>
                </div>
            </li>
        </ul>

    </div>

    <div *ngIf="earlierDepartures.length === 0 && laterHours.length === 0" class="align-center margin-top-20">
        <ridango-ui-icons name="emptySchedule"></ridango-ui-icons>
        <h1 class="margin-top-10">{{'SCHEDULE_ROUTE_STOP_DETAILS_NO_DEPARTURES_TITLE' | translate}}</h1>
        <p>{{'SCHEDULE_ROUTE_STOP_DETAILS_NO_DEPARTURES_DEPARTURES' | translate}}</p>
    </div>
</div>
